import SubscriptionPaymentsTable from './SubscriptionPaymentsTable';

export default SubscriptionPaymentsTable;
